import React, { useState, useEffect, useRef } from 'react';
import style from './HealthAlarm.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import SwitchBox from '../../../../../components/box/SwitchBox';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import Modal from '../../../../../components/comm/Modal';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import Skeleton from '@mui/material/Skeleton';


const HealthAlarm = () => {

    const [isOpen, setIsOpen] = useState(false);    //모달창
    const [alarmIdToTurnOff, setAlarmIdToTurnOff] = useState(null);
    const [alarmList, setAlarmList] = useState([]);
    const [isGlobalTurnOff, setIsGlobalTurnOff] = useState(false); // 전체 알림 끌기인지 여부
    const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const [loading, setLoading] = useState(false);

    // 화면초기화렌더 useRef 선언
    const isInitialRender = useRef(true);


    const allOn = alarmList.every((alarm) => alarm.active);

    // 개별 스위치 토글
    const toggleAlarm = (id) => {
        const current = alarmList.find((alarm) => alarm?.id === id);
        if (current.active) {
            setAlarmIdToTurnOff(id);
            setIsOpen(true);
        } else {
            const newTime = current.time || { hour: 9, minute: 0 };
            setAlarmList((prev) =>
                prev.map((alarm) =>
                    alarm.id === id
                        ? { ...alarm, active: true, time: newTime }
                        : alarm
                )
            );

            updateAlarmStatus(id, "1", newTime);
        }
    };

    // 다시 알림 스위치 토글
    const toggleRepeatSwitch = (id, status) => {
    setAlarmList(prev =>
        prev.map(a =>
            a.id === id ? { ...a, repeatOn: status } : a
        )
    );
    updateReAlarmStatus(id, status ? "1" : "0");
};

    const updateReAlarmStatus = (id, reAlrmAt) => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");
        const alarm = alarmList.find(a => a.id === id);
        const requestUrl = "/notifications/health-record/push/on";

        const time = alarm.time || { hour: 9, minute: 0 };
        const hourStr = String(time.hour).padStart(2, '0');
        const minStr = String(time.minute).padStart(2, '0');

        const requestBody = {
            idx: id,
            mainAlrmAt: alarm.active ? "1" : "0",
            reAlrmAt: reAlrmAt,
            cnncHsptlCd: alarm.cnncHsptlCd,
            cnncPatntNo: alarm.cnncPatntNo,
            alrmSetupField: `${alarm.cntsBgnDe}${hourStr}${minStr}`,
            usrUid: user?.usrUid,
            usrInfoId: user?.usrInfoId,
            pushTitle: alarm.title,
            hospital: alarm.hospital,
            department: alarm.department,
            cntsBgnDe: alarm.cntsBgnDe,
            cntsEndDe: alarm.cntsEndDe,
        };

        axiosApi.post(requestUrl, requestBody, {
            headers: { "Authorization": `Bearer ${jToken}` }
        })
        .then(() => {
            console.log("다시 알림 상태 업데이트 성공");
            if (reAlrmAt === "1") searchAlarmHealthRecordList();
        })
        .catch((err) => console.log("다시 알림 상태 업데이트 실패:", err));
    };

    // 전체 스위치 토글
    const toggleAll = () => {
        const newState = !allOn;
        if (!newState) {
            setIsGlobalTurnOff(true);
            setIsOpen(true);
        } else {
            setAlarmList((prev) =>
                prev.map((alarm) => ({ ...alarm, active: true }))
            );
            updateBulkAlarmStatus(alarmList, "1");
        }
    };

    const onDismiss = () => {
        setOpen(false);
        setSelectedId(null);
    };

    // 시간 선택 완료
    const onConfirmTime = (id, time) => {
        setAlarmList(prev =>
            prev.map(alarm => (alarm.id === id ? { ...alarm, time } : alarm))
        );
        updateAlarmStatus(id, "1", time);
        setSelectedId(null);
    };

    // 시간 포맷 함수
    const formatTime = (hour, minute) => {
        const ampm = hour < 12 ? '오전' : '오후';
        const hr = hour % 12 === 0 ? 12 : hour % 12;
        const min = String(minute).padStart(2, '0');
        return `${ampm} ${hr}:${min}`;
    };

    const cancelTurnOffAlarm = () => {
        setIsOpen(false);
        setAlarmIdToTurnOff(null);
        setIsGlobalTurnOff(false);
    };

    const confirmTurnOffAlarm = () => {
        if (isGlobalTurnOff) {
            setAlarmList((prev) =>
                prev.map((alarm) => ({ ...alarm, active: false, repeatOn: false }))
            );
            updateBulkAlarmStatus(alarmList, "0");
        } else if (alarmIdToTurnOff !== null) {
            setAlarmList((prev) =>
                prev.map((alarm) =>
                    alarm.id === alarmIdToTurnOff
                        ? { ...alarm, active: false, repeatOn: false }
                        : alarm
                )
            );
            updateAlarmStatus(alarmIdToTurnOff, "0");
        }

        setIsOpen(false);
        setAlarmIdToTurnOff(null);
        setIsGlobalTurnOff(false);
    };

    const updateBulkAlarmStatus = (alarms, mainAlrmAt) => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        const requestUrl = "/notifications/health-record/push/bulk";

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const requestBody = {
            alarmList: alarms.map(alarm => {
                const time = alarm.time || { hour: 9, minute: 0 };
                const hourStr = String(time.hour).padStart(2, '0');
                const minStr = String(time.minute).padStart(2, '0');
                const alrmSetupField = `${alarm.cntsBgnDe}${hourStr}${minStr}`;

                return {
                    idx: alarm.id,
                    mainAlrmAt: mainAlrmAt,
                    cnncHsptlCd: alarm.cnncHsptlCd,
                    cnncPatntNo: alarm.cnncPatntNo,
                    alrmSetupField: alrmSetupField,
                    usrUid: user?.usrUid,
                    usrInfoId: user?.usrInfoId,
                    pushTitle: alarm.title,
                    hospital: alarm.hospital,
                    department: alarm.department,
                    cntsBgnDe: alarm.cntsBgnDe,
                    cntsEndDe: alarm.cntsEndDe,
                };
            }),
            mainAlrmAt: mainAlrmAt
        };

        axiosApi.post(requestUrl, requestBody, requestOption)
            .then((res) => {
                console.log("일괄 알람 상태 업데이트 성공");
                searchAlarmHealthRecordList();
            })
            .catch((err) => {
                console.log("일괄 알람 상태 업데이트 실패 : ", err);
            });
    };

    const updateAlarmStatus = async (id, mainAlrmAt, timeData = null) => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const alarm = alarmList.find(a => a.id === id);

        if (!alarm) {
            console.log("알람을 찾을 수 없습니다.");
            return;
        }

        // 백엔드가 ON 시 기존 알람 자동 취소 후 재생성하므로 단순 호출
        await sendAlarmOn(id, mainAlrmAt, timeData, user, alarm);
    };

    const sendAlarmOn = async (id, mainAlrmAt, timeData, user, alarm) => {
        const requestUrl = mainAlrmAt === "1"
            ? "/notifications/health-record/push/on"
            : "/notifications/health-record/push/off";

        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const time = timeData || alarm.time;
        const hourStr = String(time.hour).padStart(2, '0');
        const minStr = String(time.minute).padStart(2, '0');
        const alrmSetupField = `${alarm.cntsBgnDe}${hourStr}${minStr}`;

        const requestBody = {
            idx: id,
            mainAlrmAt: mainAlrmAt,
            reAlrmAt: mainAlrmAt === "0" ? "0" : undefined,
            cnncHsptlCd: alarm.cnncHsptlCd,
            cnncPatntNo: alarm.cnncPatntNo,
            alrmSetupField: alrmSetupField,
            usrUid: user?.usrUid,
            usrInfoId: user?.usrInfoId,
            pushTitle: alarm.title,
            hospital: alarm.hospital,
            department: alarm.department,
            cntsBgnDe: alarm.cntsBgnDe,
            cntsEndDe: alarm.cntsEndDe,
        };

        console.log("requestBody : ", requestBody);

        try {
            await axiosApi.post(requestUrl, requestBody, requestOption);
            await searchAlarmHealthRecordList();
        } catch (err) {
            console.log("알람 업데이트 실패:", err);
        }
    };



    /**
     * 재택 치료 가이드 조회
     */
    const searchAlarmHealthRecordList = async () => {

        setLoading(true);

        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const requestUrl = "/homecare/srvey/retrieveUserAlarmHealthRecordsList";
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const requestBody = {
            usrHsptlMap: user?.usrHsptlMap
        }

        return axiosApi.post(requestUrl, requestBody, requestOption)
            .then((res) => {
                const resultData = res.data;
                console.log("=========> searchAlarmHealthRecordList resultData : ", resultData);
                if (resultData.resultCode === CODE.RCV_SUCCESS) {
                    const transformedList = resultData.result.resultList.map(item => {
                        let hour = 9, minute = 0;

                        if (item.alrmSetupField && item.alrmSetupField.length >= 12) {
                            const timeStr = item.alrmSetupField.slice(-4);
                            hour = parseInt(timeStr.substring(0, 2), 10);
                            minute = parseInt(timeStr.substring(2, 4), 10);
                        }

                        return {
                            id: item.idx,
                            title: item.cntsSj,
                            hospital: item.cnncHsptlNm,
                            department: item.deptNm,
                            period: `${item.cntsBgnDe} ~ ${item.cntsEndDe}`,
                            active: item.mainAlrmAt === "1",
                            repeatOn: item.reAlrmAt === "1",
                            time: { hour, minute },
                            cnncHsptlCd: item.cnncHsptlCd,
                            cnncPatntNo: item.cnncPatntNo,
                            cntsBgnDe: item.cntsBgnDe,
                            cntsEndDe: item.cntsEndDe,
                            pushTrsmId: item.pushTrsmId,
                            alrmSetupField: item?.alrmSetupField
                        };
                    });
                    setAlarmList(transformedList);
                } else {
                    setAlarmList([]);
                }
            })
            .catch((err) => {
                console.log("=========> err : ", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    useEffect(() => {
        if (isInitialRender.current) {
            searchAlarmHealthRecordList();
            isInitialRender.current = false;
        }
    }, []);

    /* 기간 포맷 변환 */

    const formatPeriod = (periodStr) => {
        if (!periodStr || !periodStr.includes('~')) return '';

        const [start, end] = periodStr.split('~').map(s => s.trim());

        if (start.length < 8 || end.length < 8) return '';

        const startDate = new Date(
            `${start.substring(0, 4)}-${start.substring(4, 6)}-${start.substring(6, 8)}`
        );
        const endDate = new Date(
            `${end.substring(0, 4)}-${end.substring(4, 6)}-${end.substring(6, 8)}`
        );

        // 날짜 차이 계산
        const diffDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

        // YY.MM.DD 형식으로 변환
        const format = (date) =>
            `${String(date.getFullYear()).substring(2)}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;

        return `${format(startDate)}~${format(endDate)} (총 ${diffDays}일)`;
    };



    return (
        <>
            <HeadSub title="건강 기록 알림 설정" />

            <div className={style['top-bar-box']}>
                <span>전체 알림</span>
                <SwitchBox toggles={allOn} status={toggleAll} />
            </div>

            <div id="sub-content" data-type="a">
                <div className="inner-wrap" data-pad="normal">

                    {loading ? (
                        // 스켈레톤 로딩
                        <>
                            {[1, 2, 3].map((item) => (
                                <div className={style['health-alarm-box']} key={item}>
                                    <div className={style['innerbox']}>
                                        <div className={style['health-name-box']}>
                                            <Skeleton variant="text" width="60%" height={24} />
                                        </div>
                                        <Skeleton variant="text" width="40%" />
                                        <div className={style['alarm-box']}>
                                            <Skeleton variant="text" width="30%" />
                                            <Skeleton variant="text" width="40%" />
                                        </div>
                                        <div className={style['alarm-box']}>
                                            <Skeleton variant="text" width="20%" />
                                            <Skeleton variant="text" width="50%" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : alarmList.length === 0 ? (
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}>
                                <object data={noDataImg} aria-hidden='true'></object>
                            </div>
                            <p> 등록된 알림이 없습니다.</p>
                        </div>
                    ) : (
                        <>
                            <div className={style['check-point-box']}>
                                <strong>꼭 확인해주세요!</strong>
                                <ul>
                                    <li>알림이 적용되기까지 최대 30분 정도 걸릴 수 있습니다.</li>
                                </ul>
                            </div>
                            {alarmList.map((alarm, index) => (
                                <div
                                    key={alarm.idx || `alarm-${index}`}
                                    className={style['health-alarm-box']}
                                >
                                    <div className={style['innerbox']}>
                                        <div className={style['health-name-box']}>
                                            <span>{alarm.title}</span>
                                        </div>
                                        <div className={style['alarm-box']}>
                                            {alarm.alrmSetupField ? (
                                                <strong
                                                    className={!alarm.active ? style['no-alarm'] : ''}
                                                    onClick={() => alarm.active && setSelectedId(alarm.id)}
                                                >
                                                    {(() => {
                                                        const timeStr = alarm.alrmSetupField.slice(-4);
                                                        const hour = parseInt(timeStr.substring(0, 2), 10);
                                                        const minute = parseInt(timeStr.substring(2, 4), 10);
                                                        return formatTime(hour, minute);
                                                    })()}
                                                </strong>
                                            ) : (
                                                <strong className={style['no-alarm']}>
                                                    알림 없음
                                                </strong>
                                            )}

                                            <div data-swich-size="sm">
                                                <SwitchBox
                                                    toggles={alarm.active}
                                                    status={() => toggleAlarm(alarm.id)}
                                                />
                                            </div>
                                        </div>
                                        <div className={style['infom-wrap']}>
                                            {alarm.active && (
                                                <div className="animation-1">
                                                    <div className={style["infom-box"]}>
                                                        <p className={style["tit"]}>다시 알림 설정</p>
                                                        <SwitchBox
                                                            size="small"
                                                            status={(status) => toggleRepeatSwitch(alarm.id, status)}
                                                            toggles={alarm.repeatOn}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            <div className={style['infom-box']}>
                                                <p className={style['tit']}>
                                                    처방 정보
                                                </p>
                                                <p>
                                                    <span>{alarm.hospital}</span>
                                                    <span>{alarm.department}</span>
                                                </p>
                                            </div>
                                            <div className={style['infom-box']}>
                                                <p className={style['tit']}>기간</p>
                                                {/* <span>{alarm.period}</span> */}
                                                <span>{formatPeriod(alarm.period)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={selectedId !== null}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        {selectedId !== null && (
                            <CustomTimePicker
                                onClose={onDismiss}
                                onConfirm={(time) => onConfirmTime(selectedId, time)}
                                titleTxt="알림 시간 선택"
                                initialTime={alarmList.find((a) => a.id === selectedId)?.time}
                            />
                        )}
                    </BottomSheet>


                    <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                        <div className='modal-box' data-type="a">
                            <div className='modal-top-box'>
                                <div className='title-box'>
                                    <p> 알림을 끄시겠어요?</p>
                                </div>
                            </div>

                            <div className="modal-bottom-box">
                                <div className='btn-layout'>
                                    <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelTurnOffAlarm}>
                                        <span>취소</span>
                                    </button>
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={confirmTurnOffAlarm}>
                                        <span>끄기</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>



                </div>
            </div>
        </>
    );
};

export default HealthAlarm;
